import { Observable, pipe, switchMap } from "rxjs";
export const blob2json = () => pipe(switchMap((response) => {
    // Chuyển đổi Blob thành JSON và trả về một Observable
    return new Observable((observer) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            try {
                const jsonData = JSON.parse(reader.result);
                observer.next(jsonData);
                observer.complete();
            }
            catch (error) {
                console.error('Error parsing JSON:', error);
                observer.error(error);
            }
        };
        reader.readAsText(response);
    });
}));
export const blob2jsonFn = (blob) => {
    try {
        const url = URL.createObjectURL(blob);
        let xmlRequest = new XMLHttpRequest();
        xmlRequest.open('GET', url, false);
        xmlRequest.send();
        URL.revokeObjectURL(url);
        return JSON.parse(xmlRequest.responseText);
    }
    catch (error) {
        console.error('Error parsing JSON:', error);
        return null;
    }
};
//# sourceMappingURL=blob2json.js.map